module.exports = "/images/material-design-form.jpg?aa0ea8ae1143ef04ad7566b54d76f149";